import { styled, TableCell, TableCellProps } from '@mui/material'
import { ReactNode } from 'react'

interface TableItemCellProps extends TableCellProps {
  children: ReactNode
}

export const TableItemCell = ({ children, ...rest }: TableItemCellProps) => (
  <StyledTableItemCell {...rest}> {children}</StyledTableItemCell>
)

const StyledTableItemCell = styled(TableCell)(({ theme }) => ({
  borderBottom: `0.5px solid ${theme.palette.divider}`,
}))
